/*!
 * TPP — search placeholder typewriter (Force-style)
 * Applies to all 4 header contexts (desktop / mobile / sticky / inner pages).
 * Reads settings from window.TPP_SEARCH_ROTATOR injected by sections/header-categories-menu.liquid
 * (Theme Editor → Header main → Search placeholder rotator). Falls back to defaults below.
 */
(function () {
  if (window.__tppSearchPlaceholderInit) return;
  window.__tppSearchPlaceholderInit = true;

  var DEFAULTS = {
    enabled: true,
    prefix: 'Search for ',
    phrasesRaw:
      'fuel injectors\n' +
      'front radar\n' +
      'ABS unit\n' +
      'brake chamber\n' +
      'air dryer\n' +
      'turbocharger\n' +
      'EGR valve\n' +
      'wiring harness\n' +
      'foot brake valve\n' +
      'exhaust fluid header',
    typingSpeed: 90,
    holdWord: 2200
  };

  var cfg = Object.assign({}, DEFAULTS, window.TPP_SEARCH_ROTATOR || {});
  if (cfg.enabled === false) return;

  var PREFIX = String(cfg.prefix || DEFAULTS.prefix).replace(/\s+$/, '');
  if (PREFIX) PREFIX += ' ';

  function placeholderText(tail, typedLength) {
    var part = tail.substring(0, typedLength || tail.length);
    return PREFIX + part;
  }
  var TAILS = String(cfg.phrasesRaw || '')
    .split(/\r?\n/)
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  if (TAILS.length === 0) TAILS = DEFAULTS.phrasesRaw.split('\n');

  var TYPING_SPEED = Number(cfg.typingSpeed) || DEFAULTS.typingSpeed;
  var DELETING_SPEED = Math.max(20, Math.round(TYPING_SPEED * 0.6));
  var DELAY_AFTER_TYPED = Number(cfg.holdWord) || DEFAULTS.holdWord;
  var DELAY_AFTER_DELETING = 350;
  var DELAY_FIRST = 1400;

  var SELECTOR = 'input.t4s-search-header__input, input.t4s-mini-search__input, input.hdt-search__input, input.hdt-search_input, input[data-input-search], form[action="/search"] input[name="q"]';

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function attach(input) {
    if (input.__tppRotator) return;
    input.__tppRotator = true;

    var tails = shuffle(TAILS);
    var idx = 0;

    input.setAttribute('placeholder', placeholderText(tails[idx]));

    var focused = false;
    var timer = null;
    var prefixLen = PREFIX.length;

    input.addEventListener('focus', function () { focused = true; });
    input.addEventListener('blur',  function () { focused = false; });

    function del(done) {
      timer = setInterval(function () {
        if (focused || !input.isConnected) return;
        var cur = input.getAttribute('placeholder') || '';
        if (cur.length <= prefixLen) {
          clearInterval(timer);
          done();
          return;
        }
        input.setAttribute('placeholder', cur.substring(0, cur.length - 1));
      }, DELETING_SPEED);
    }

    function type(tail, done) {
      var i = 0;
      timer = setInterval(function () {
        if (focused || !input.isConnected) return;
        i++;
        input.setAttribute('placeholder', placeholderText(tail, i));
        if (i >= tail.length) {
          clearInterval(timer);
          done();
        }
      }, TYPING_SPEED);
    }

    function loop() {
      if (!input.isConnected) return;
      idx = (idx + 1) % tails.length;
      var tail = tails[idx];
      del(function () {
        setTimeout(function () {
          type(tail, function () {
            setTimeout(loop, DELAY_AFTER_TYPED);
          });
        }, DELAY_AFTER_DELETING);
      });
    }

    setTimeout(loop, DELAY_FIRST);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(attach);
  }

  function boot() {
    scan(document);

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SELECTOR)) attach(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () { scan(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
